import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-已办",
  "use": "icon-已办-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-已办\"><path d=\"M794.4192 223.1424h-127.9872v-38.4a25.6 25.6 0 0 0-25.6-25.6H436.0704a25.6 25.6 0 0 0-25.6 25.6v38.4h-127.9872a76.8 76.8 0 0 0-76.7872 76.7872v537.536a76.8 76.8 0 0 0 76.7872 76.7872h511.936a76.8 76.8 0 0 0 76.7872-76.7872V299.9296a76.8 76.8 0 0 0-76.7872-76.7872z m-332.7616-12.8h153.5872v76.7872H461.6576v-76.7872z m358.3616 115.1872v511.936a25.6 25.6 0 0 1-25.6 25.6H282.4832a25.6 25.6 0 0 1-25.6-25.6V299.9296a25.6 25.6 0 0 1 25.6-25.6H410.4704v38.4a25.6 25.6 0 0 0 25.6 25.6h204.7744a25.6 25.6 0 0 0 25.6-25.6v-38.4H794.432a25.6 25.6 0 0 1 25.6 25.6v25.6zM647.0528 461.0048L512.8576 595.2l-70.208-70.208a25.6 25.6 0 1 0-36.1984 36.1984l88.3072 88.3072a25.6 25.6 0 0 0 36.1984 0l152.2944-152.2944a25.6 25.6 0 1 0-36.1984-36.1984z\" p-id=\"1620\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/已办.svg
// module id = jXyS
// module chunks = 75